import { Record } from 'immutable';

export default class OneflowTemplateRecord extends Record({
  id: undefined,
  name: undefined,
}) {
}
